module.exports = __webpack_public_path__ + "static/media/socialmarketplace.d14d98cd.jpg";